<template>
  <div class="picky-cat-feed-combination__tabs">
    <div class="picky-cat-feed-combination__tabs-nav">
      <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="picky-cat-feed-combination__tabs-nav-item"
          :class="{'_active': activeTabIndex === index}"
          @click="selectTab(tab, index)"
      >
        {{ tab.title }}
      </div>
    </div>
    <div class="picky-cat-feed-combination__tabs-content">
      <div class="picky-cat-feed-combination__tabs-tab">
        <div class="picky-cat-feed-combination__tabs-inner">
          <div class="picky-cat-feed-combination__tabs-image">
            <img src="/themes/custom/purina_one/purina-one-new_cat/src/img/picky-cat/feed-combination.png" alt="">
          </div>
          <div class="picky-cat-feed-combination__tabs-badge _dry">
            <div class="picky-cat-feed-combination__tabs-badge_title">
              Сухой корм
            </div>
            <div class="picky-cat-feed-combination__tabs-badge_weight">
              {{ activeTab.feedDry }}
            </div>
            <span>в день</span>
          </div>
          <div class="picky-cat-feed-combination__tabs-badge _wet">
            <div class="picky-cat-feed-combination__tabs-badge_title">
              Влажный корм
            </div>
            <div class="picky-cat-feed-combination__tabs-badge_weight">
              {{ activeTab.feedWet }}
              <div class="tooltip tooltip-pack">
                <button class="tooltip__trigger tooltip-pack__trigger">
                  <svg width="2" height="8" viewBox="0 0 2 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.9" d="M0.216094 8V2.62H1.77609V8H0.216094ZM0.996094 1.87C0.709427 1.87 0.476094 1.78667 0.296094 1.62C0.116094 1.45333 0.0260938 1.24667 0.0260938 1C0.0260938 0.753333 0.116094 0.546666 0.296094 0.38C0.476094 0.213333 0.709427 0.129999 0.996094 0.129999C1.28276 0.129999 1.51609 0.21 1.69609 0.37C1.87609 0.523333 1.96609 0.723333 1.96609 0.97C1.96609 1.23 1.87609 1.44667 1.69609 1.62C1.52276 1.78667 1.28943 1.87 0.996094 1.87Z" fill="#73317A"/>
                  </svg>
                </button>
                <div class="tooltip__content tooltip-pack__message" v-html="tooltip" />
              </div>
            </div>
            <span>в день</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  tabs: {
    type: Array,
    default: []
  },
  tooltip: {
    type: String,
    default: ''
  }
});

let activeTab = ref(props.tabs[0]);
let activeTabIndex = ref(0);

const selectTab = (tab, index) => {
  activeTab.value = tab;
  activeTabIndex.value = index;
}
</script>